import type { ProcessoArbitralStatus } from '@/features/arbitral';

import { STATUS_PAI_LABELS } from '../types/situacaoArbitralTypes';

export function statusPaiLabel(statusPai: string | null): string {
  if (!statusPai) return '—';
  if (statusPai in STATUS_PAI_LABELS) {
    return STATUS_PAI_LABELS[statusPai as ProcessoArbitralStatus];
  }
  return statusPai;
}

export function resumoEscopo(situacao: { isShared: boolean; escritorioIds: string[] }): string {
  if (situacao.isShared || situacao.escritorioIds.length === 0) return 'Global';
  const total = situacao.escritorioIds.length;
  return `${total} câmara${total > 1 ? 's' : ''}`;
}

export function escritoriosMudaram(anterior: string[], atual: string[]): boolean {
  if (anterior.length !== atual.length) return true;
  const conjunto = new Set(anterior);
  return atual.some((id) => !conjunto.has(id));
}
